export const searchFormConfig = {
  formItems: [
    {
      field: 'key',
      type: 'input',
      label: 'terminal.brand-name'
    },
    {
      field: 'order',
      type: 'input',
      label: 'terminal.order'
    },
    // {
    //   field: 'status',
    //   type: 'select',
    //   label: 'general.status'
    // },
    {
      field: 'createTime',
      type: 'datepicker',
      label: 'general.creation-date',
      otherOptions: {
        type: 'daterange'
      },
      dateFieldName: ['startDateTime', 'endDateTime']
    }
  ]
}
